import moment from "moment";
import Grid from "@mui/material/Grid";
import { Autocomplete, Box, Chip, ControlLabelCheckBox, DatePicker, FormField } from "@maysoft/common-component-react";

import Helpers from "commons/helpers";
import Strings from "constants/strings";

import { IDataFilterReport } from ".";
import { ICodename } from "commons/interfaces";
import { BooleanInt } from "constants/enum";



export const FilterForm = ({
    dataGroups,
    dataTags,
    dataFilterTemp,
    dataMapCodenames,
    setDataFilterTemp,
}: {
    dataGroups: ICodename[];
    dataTags: ICodename[];
    dataMapCodenames: any;
    dataFilterTemp: IDataFilterReport;
    setDataFilterTemp: React.Dispatch<React.SetStateAction<IDataFilterReport>>;
}) => {
    return (
        <Grid container spacing={3}>
            <Grid item xs={6}>
                <DatePicker
                    label="Từ"
                    placeholder="Nhập thời gian"
                    value={Helpers.toUnix(dataFilterTemp?.startDate)}
                    onChangeValue={(value) => {
                        const val = !Helpers.isNullOrEmpty(value) ? moment(value).startOf("day").unix() : undefined;
                        setDataFilterTemp(prev => ({
                            ...prev,
                            startDate: val,
                        }));
                    }}
                />
            </Grid>
            <Grid item xs={6}>
                <DatePicker
                    label="Đến"
                    placeholder="Nhập thời gian"
                    value={Helpers.toUnix(dataFilterTemp?.endDate)}
                    onChangeValue={(value) => {
                        const val = !Helpers.isNullOrEmpty(value) ? moment(value).endOf("day").unix() : undefined;
                        setDataFilterTemp(prev => ({
                            ...prev,
                            endDate: val,
                        }));
                    }}
                />
            </Grid>
            <Grid item xs={12}>
                <FormField
                    label={Strings.REPORT.SEARCH_TEXT}
                    value={dataFilterTemp?.searchText || ""}
                    placeholder={Strings.MONITORING.PLACEHOLDER_SEARCH_TEXT}
                    onChangeValue={(val) => {
                        setDataFilterTemp(prev => ({
                            ...prev,
                            searchText: val,
                        }));
                    }}
                />
            </Grid>
            <Grid item xs={12}>
                <Autocomplete
                    label={Strings.REPORT.REPORT_STATUS}
                    defaultValue={dataFilterTemp?.reportStatus}
                    data={[...dataMapCodenames?.reportStatus || []]}
                    placeholder={Strings.REPORT.SELECT_REPORT_STATUS}
                    onChange={(val: any) => {
                        setDataFilterTemp(prev => ({
                            ...prev,
                            reportStatus: val,
                        }));
                    }}
                />
            </Grid>
            <Grid item xs={12}>
                <Autocomplete
                    data={dataGroups}
                    label={Strings.REPORT.DEPARTMENT}
                    defaultValue={dataFilterTemp?.departmentId}
                    placeholder={Strings.REPORT.SELECT_DEPARTMENT}
                    onChange={(val: any) => {
                        setDataFilterTemp(prev => ({
                            ...prev,
                            departmentId: val,
                        }));
                    }}
                />
            </Grid>
            <Grid item xs={12}>
                <Autocomplete
                    multiple
                    label={Strings.REPORT.TAG}
                    defaultValue={dataFilterTemp?.tagIds || []}
                    data={dataTags}
                    placeholder={Strings.REPORT.SELECT_TAG}
                    onChange={(val: any) => {
                        setDataFilterTemp(prev => ({
                            ...prev,
                            tagIds: val || [],
                        }));
                    }}
                />
            </Grid>
            <Grid item xs={12} sx={{ ml: -1 }}>
                <ControlLabelCheckBox
                    label={Strings.REPORT.ANONYMOUS_REPORT}
                    value={dataFilterTemp?.anonymousReporter === BooleanInt.True}
                    onChangeValue={(checked) => {
                        setDataFilterTemp(prev => ({
                            ...prev,
                            anonymousReporter: checked ? BooleanInt.True : BooleanInt.False
                        }));
                    }}
                />
            </Grid>
        </Grid>
    )
};

export const BoxValueFilter = ({
    dataGroups,
    dataTags,
    dataFilter,
    dataMapCodenames,
    handleFilterData,
}: {
    dataGroups: ICodename[];
    dataTags: ICodename[];
    dataMapCodenames: any;
    dataFilter: IDataFilterReport;
    handleFilterData: (req: IDataFilterReport) => void;
}) => {
    return (
        <Box paddingBottom={1}>
            {(
                !Helpers.isNullOrEmpty(dataFilter?.endDate) &&
                !Helpers.isNullOrEmpty(dataFilter?.startDate) &&
                (dataFilter?.endDate !== 0) && (dataFilter?.endDate !== "0") &&
                (dataFilter?.startDate !== 0) && (dataFilter?.startDate !== "0")
            ) &&
                <Chip
                    label={`${Strings.COMMON.FROM}: ${Helpers.dateToString(Number(dataFilter?.startDate))} - ${Strings.COMMON.TO}: ${Helpers.dateToString(Number(dataFilter?.endDate))}`}
                    value={""}
                    onDelete={() => {
                        handleFilterData({
                            ...dataFilter,
                            endDate: moment().endOf("y").unix(),
                            startDate: moment().startOf("y").unix(),
                        });
                    }}
                />
            }
            {!Helpers.isNullOrEmpty(dataFilter?.reportStatus) &&
                <Chip
                    label={Strings.REPORT.REPORT_STATUS}
                    value={[...dataMapCodenames?.reportStatus || []].find(e => e.code === dataFilter?.reportStatus)?.name}
                    onDelete={() => {
                        handleFilterData({
                            ...dataFilter,
                            reportStatus: undefined,
                        });
                    }}
                />
            }
            {!Helpers.isNullOrEmpty(dataFilter?.departmentId) &&
                <Chip
                    label={Strings.REPORT.DEPARTMENT}
                    value={dataGroups.find(e => e.code === dataFilter?.departmentId)?.name}
                    onDelete={() => {
                        handleFilterData({
                            ...dataFilter,
                            departmentId: undefined,
                        });
                    }}
                />
            }
            {[...dataFilter?.tagIds || []].map(tagId =>
                <Chip
                    key={tagId}
                    label={Strings.REPORT.TAG}
                    value={dataTags.find(e => e.code === tagId)?.name}
                    onDelete={() => {
                        handleFilterData({
                            ...dataFilter,
                            tagIds: [...dataFilter?.tagIds || []].filter(e => e !== tagId),
                        });
                    }}
                />
            )}
        </Box>
    );
};